module.exports = __webpack_public_path__ + "static/media/998134.98bcf57a.png";